// Copyright 2026 Bitech.id. Licensed under the MIT License.

import type { BiwaveClient } from '@biwave/core';

export function installUnhandledRejectionHandler(client: BiwaveClient): () => void {
  const handler = (event: PromiseRejectionEvent) => {
    client.captureException(event.reason, 'error', undefined, {
      type: 'onunhandledrejection',
      handled: false,
    });
  };

  window.addEventListener('unhandledrejection', handler);

  return () => {
    window.removeEventListener('unhandledrejection', handler);
  };
}
